import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DadosComumService {

  constructor() { }

  public NoExecutionReasons: Object[] = [
    { id: 1, text: 'Cancelado com Antecedência' },
    { id: 2, text: 'Não Comparecimento do Paciente' },
  ];

  public StatusAppointment: Object[] = [
    { id: 1, text: 'Solicitado' },
    { id: 2, text: 'Finalizado' },
    { id: 3, text: 'Cancelado' },
    { id: 4, text: 'Agendado' },
    { id: 5, text: 'Disponível' },
    { id: 6, text: 'Não Compareceu' }
  ];

  public simNao: Object[] = [
    { id: 'S', text: 'SIM' },
    { id: 'N', text: 'NÃO' }
  ];

  public Meatoscopia: Object[] = [
    { id: 'N', text: 'NORMAL' },
    { id: 'A', text: 'ALTERADO (CERÚMEN)' }
  ];

  public ReferencialSequencial: Object[] = [
    { id: 'R', text: 'REFERENCIAL' },
    { id: 'S', text: 'SEQUENCIAL' }
  ];

  public ResultadoExame: Object[] = [
    { id: 'N', text: 'NORMAL' },
    { id: 'A', text: 'ALTERADO' },
    { id: 'RI', text: 'REQUER INTERPRETAÇÃO' },
    { id: 'E', text: 'ESTÁVEL' },
    { id: 'AG', text: 'AGRAVAMENTO' }
  ];

  public TipoExame: Object[] = [
    { id: 'A', text: 'ADMISSIONAL' },
    { id: 'D', text: 'DEMISSIONAL' },
    { id: 'C', text: 'CONSULTA' },
    { id: 'M', text: 'MUDANÇA FUNÇÃO' },
    { id: 'N', text: 'ANÁLISE PONTUAL' },
    { id: 'R', text: 'RETORNO AO TRABALHO' },
    { id: 'P', text: 'PERIÓDICO' },
  ];

  public TipoAtendimento: Object[] = [
    { id: 'A', text: 'ADMISSIONAL' },
    { id: 'D', text: 'DEMISSIONAL' },
    { id: 'C', text: 'CONSULTA' },
    { id: 'M', text: 'MUDANÇA FUNÇÃO' },
    { id: 'X', text: 'MUDANÇA FUNÇÃO (EXT)' },
    { id: 'N', text: 'ANÁLISE PONTUAL' },
    { id: 'R', text: 'RETORNO AO TRABALHO' },
    { id: 'P', text: 'PERIÓDICO' },
    { id: 'E', text: 'EXEC. COMPLEMENTAR' },
  ];

  public AptoInapto: Object[] = [
    { id: 'A', text: 'APTO' },
    { id: 'I', text: 'INAPTO' }
  ];

  public TipoAssinaturas: Object[] = [
    { id: 1, text: 'Manual' },
    { id: 2, text: 'SMOVault' },
    { id: 3, text: 'SMODocs' },
    { id: 4, text: 'Biometria' }
  ];

  public OcupacionalNaoOcupacional: Object[] = [
    { id: 'O', text: 'OCUPACIONAL' },
    { id: 'N', text: 'NÃO OCUPACIONAL' }
  ];

  public exameNaturezaIdParaTexto(id: number): string {
    if (id === 6)
      return 'CLINICO OCUPACIONAL';

    return '-';
  }

  public atendimentoTipoParaTexto(id: string): string {
    if (id === 'A')
      return 'ADMISSIONAL';
    if (id === 'D')
      return 'DEMISSIONAL';
    if (id === 'C')
      return 'CONSULTA';
    if (id === 'M')
      return 'MUDANÇA FUNÇÃO';
    if (id === 'X')
      return 'MUDANÇA FUNÇÃO';
    if (id === 'N')
      return 'ANÁLISE PONTUAL';
    if (id === 'R')
      return 'RETORNO AO TRABALHO';
    if (id === 'P')
      return 'PERIÓDICO';
    if (id === 'E')
      return 'EXEC. COMPLEMENTAR';

    return '-';
  }

  public TipoAtestadoMedico: Object[] = [
    { id: 0, text: 'Doença Não Ocupacional' },
    { id: 1, text: 'Acidente Trabalho' },
    { id: 2, text: 'Doença Ocupacional' },
    { id: 3, text: 'Acidente Não Ocupacional' }
  ];

  public gravidades: Object[] = [
    { id: 1, text: 'LEVE' },
    { id: 2, text: 'MODERADA' },
    { id: 3, text: 'GRAVE' }
  ];
}
